import { connect } from 'react-redux'
import UnionInfo from '../views/UnionInfo'
import { listUnionInfo, addUnionInfo, deleteUnionInfo, updateUnionInfo,
          updateClubInfo, addClubInfo, deleteClubInfo, 
          addAgentInfo, deleteAgentInfo, updateAgentInfo,
          addSubAgentInfo, deleteSubAgentInfo, updateSubAgentInfo,
          saveUnionAPlist, saveClubAPlist, saveAgentAPlist, saveSubAgentAPlist,
          deleteAllAP
      } from '../action/userAction'

function mapStateToProps (state, ownProps) {
  let union_info = state.getIn(['data','union_info']);
  return {
    union_info: union_info,
  };
  
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onLoad:() =>{
      // dispatch(listClubInfo());
      dispatch(listUnionInfo());
    },
    onSubmitNewUnion:(union) =>{
      dispatch(addUnionInfo(union));
    },
    onDeleteUnion:(id) =>{
      dispatch(deleteUnionInfo(id));
    },
    onUpdateUnion:(union) =>{
      dispatch(updateUnionInfo(union));
    },
    onSubmitNewClub:(unionID, club) =>{
      dispatch(addClubInfo(unionID, club));
    },
    onDeleteClub:(unionID,id) =>{
      dispatch(deleteClubInfo(unionID,id));
    },
    onUpdateClub:(unionID,club) =>{
      dispatch(updateClubInfo(unionID,club));
    },
    onSubmitNewAgent:(unionID,clubID,agent) =>{
      dispatch(addAgentInfo(unionID,clubID,agent));
    },
    onDeleteAgent:(unionID,clubID,id) =>{
      dispatch(deleteAgentInfo(unionID,clubID,id));
    },
    onUpdateAgent:(unionID,clubID,agent) =>{
      dispatch(updateAgentInfo(unionID,clubID,agent));
    },
    onSubmitNewSubAgent:(unionID,clubID,agentID,subAgent) =>{
      dispatch(addSubAgentInfo(unionID,clubID,agentID,subAgent));
    },
    onDeleteSubAgent:(unionID,clubID,agentID,subAgentID) =>{
      dispatch(deleteSubAgentInfo(unionID,clubID,agentID,subAgentID));
    },
    onUpdateSubAgent:(unionID,clubID,agentID,subAgent) =>{
      dispatch(updateSubAgentInfo(unionID,clubID,agentID,subAgent));
    },
    onSaveUnionAPlist:(unionID,aplist) =>{
      dispatch(saveUnionAPlist(unionID,aplist));
    },
    onSaveClubAPlist:(unionID,clubID,aplist) =>{
      dispatch(saveClubAPlist(unionID,clubID,aplist));
    },
    onSaveAgentAPlist:(unionID,clubID,agentID,aplist) =>{
      dispatch(saveAgentAPlist(unionID,clubID,agentID,aplist));
    },
    onSaveSubAgentAPlist:(unionID,clubID,agentID,subAgentID,aplist) =>{
      dispatch(saveSubAgentAPlist(unionID,clubID,agentID,subAgentID,aplist));
    },
    confirmDeleteAllAP:(unionID,clubID,agentID,subAgentID,aplist) =>{
      dispatch(deleteAllAP(unionID,clubID,agentID,subAgentID,aplist));
    },


})

const UnionInfoContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UnionInfo)

export default UnionInfoContainer